module.exports = __webpack_public_path__ + "media/images/header-users-fee505bb8279aba21927efd0218fafc9.svg";